import GdsApi from '~/glm/utils/gds-api';
import GuestCandidateCollection from '~/glm/models/shared/guest-import/guest-candidate-collection';
import { getChangedProps } from '~/glm/utils/analytics';

class ImportGuestCandidateCollection extends GuestCandidateCollection {
  constructor(analyticsStore) {
    super();
    this.analyticsStore = analyticsStore;
  }

  static importApiEndpoint = '/v1/households/import';

  trackBulkImport = households => {
    const promises = [households];
    households.forEach(({ people, address }) => {
      people.forEach(guest => {
        const trackingParams = {
          source: 'import from spreadsheet',
          ...getChangedProps({
            guestFirstName: guest.firstName,
            guestLastName: guest.lastName,
            guestPhoneNumber: guest.phone,
            guestEmail: guest.email,
            guestAddress: address,
          }),
        };
        promises.push(this.analyticsStore.track('Guest Added', trackingParams));
      });
    });
    return Promise.all(promises);
  };

  saveGuests(eventIds = []) {
    if (this.count < 1) return Promise.resolve();

    const importRows = this.validGuests.map(guest => ({
      names: guest.names.trim(),
      phone: guest.phone.trim(),
      email: guest.email.trim(),
      address: guest.address,
    }));
    const body = {
      rows: importRows,
      eventIds,
    };

    return GdsApi.post(ImportGuestCandidateCollection.importApiEndpoint, body)
      .then(res => this.trackBulkImport(res))
      .then(promiseArray => promiseArray[0]);
  }
}

export default ImportGuestCandidateCollection;
